module.exports = __webpack_public_path__ + "img/stores.d9167b14.svg";